import React from 'react';
import styled, { keyframes } from 'styled-components';
import EmptyAvatar from '../svgs/EmptyAvatar';
import { Flex } from 'pcln-design-system';
import { motion } from 'framer-motion';
const createAudioWaveAnimation = (minHeight, maxHeight) => keyframes(["0%,100%{height:", "px;}50%{height:", "px;}"], minHeight, maxHeight);
const AudioBarContainer = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "AudioWaveAnimation__AudioBarContainer",
  componentId: "sc-tiho85-0"
})(["display:inline-flex;justify-content:center;align-items:center;width:34px;height:34px;background-color:white;border-radius:50%;z-index:1000;position:relative;margin-top:-16px;top:8px;box-sizing:border-box;svg{width:32px;height:32px;}"]);
function getRandomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
const Bar = /*#__PURE__*/styled.div.withConfig({
  displayName: "AudioWaveAnimation__Bar",
  componentId: "sc-tiho85-1"
})(["background-color:white;width:1.37px !important;height:5px;border-radius:0;margin:0 0.5px;animation:", " ", "s ease-in-out infinite;"], ({
  minHeight,
  maxHeight
}) => createAudioWaveAnimation(minHeight, maxHeight), ({
  animationDuration
}) => animationDuration);
const BarWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "AudioWaveAnimation__BarWrapper",
  componentId: "sc-tiho85-2"
})(["position:absolute;width:32px;height:32px;justify-content:center;align-items:center;"]);
const AudioWaveAnimation = () => {
  return React.createElement(AudioBarContainer, {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 1
    }
  }, React.createElement(EmptyAvatar, null), React.createElement(BarWrapper, null, React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 2,
    maxHeight: 5
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 5,
    maxHeight: 7
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 7,
    maxHeight: 10
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 10,
    maxHeight: 12
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 12,
    maxHeight: 15
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 10,
    maxHeight: 12
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 7,
    maxHeight: 10
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 5,
    maxHeight: 7
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 2,
    maxHeight: 5
  })));
};
export default AudioWaveAnimation;